export const IS_WALLET_CONNECTED = "isWalletConnected";
